import { InfoTip } from './InfoTip';
import { METRIC_INFO, type MetricInfoKey } from './metricInfo';
import styles from './MetricCard.module.css';

interface MetricCardProps {
    infoKey: MetricInfoKey;
    title: string;
    value: string;
    caption: string;
    highlight?: boolean;
    tipAlign?: 'start' | 'end';
    /** Link no rodape do card (ex.: "Ver contas na tabela"). */
    action?: { label: string; onClick: () => void; active?: boolean };
    /** Texto no rodape quando o card nao tem detalhe (ex.: "Sem dados suficientes para detalhar"). */
    footnote?: string;
}

export function MetricCard({ infoKey, title, value, caption, highlight = false, tipAlign = 'end', action, footnote }: MetricCardProps) {
    return (
        <article className={`${styles.card} ${highlight ? styles.highlight : ''}`}>
            <header className={styles.header}>
                <h4 className={styles.title}>{title}</h4>
                <InfoTip info={METRIC_INFO[infoKey]} label={title} align={tipAlign} />
            </header>
            <p className={styles.value}>{value}</p>
            <p className={styles.caption}>{caption}</p>
            {action && (
                <button
                    type="button"
                    className={`${styles.action} ${action.active ? styles.actionActive : ''}`}
                    aria-pressed={action.active}
                    onClick={action.onClick}
                >
                    {action.label} →
                </button>
            )}
            {!action && footnote && <p className={styles.footnote}>{footnote}</p>}
        </article>
    );
}
